import { en } from '@/shared/lib/common/i18n';
import InvalidSession from '@/shared/ui/components/InvalidSession';
import type { RoutePathDefinition } from '../../types';

export const quickUploadSectionRoutes: RoutePathDefinition[] = [
  { path: '', Component: () => <InvalidSession feedback={en.upload.quickUpload.invalidSessionMessage} /> },
  {
    path: ':sessionId',
    lazy: () => import('@/pages/upload').then(m => ({ Component: m.QuickUploadStart }))
  },
  {
    path: ':sessionId/medications',
    lazy: () => import('@/pages/upload/ui/upload-medications').then(m => ({ Component: m.default }))
  },
  {
    path: ':sessionId/insurance',
    lazy: () => import('@/pages/upload/ui/UploadInsurance').then(m => ({ Component: m.default }))
  },
  {
    path: ':sessionId/combine-pdf',
    lazy: () => import('@/pages/upload/ui/upload-combine-pdf').then(m => ({ Component: m.default }))
  },
  { path: 'thanks', lazy: () => import('@/pages/upload/ui/thanks').then(m => ({ Component: m.default })) },
  { path: '*', Component: () => <InvalidSession feedback={en.upload.quickUpload.routeNotFoundMessage} /> }
];
